// extracted by mini-css-extract-plugin
module.exports = {"container":"page-container-3JLhPp"};